import { clone, groupBy } from 'lodash';

class OrderRefundController {
    constructor(moneyService, refundService, messageService) {
        this.moneyService = moneyService;
        this.refundService = refundService;
        this.messageService = messageService;
    }

    $onInit () {
        this.refundAmount = this.order.refundable_amount;
        this.transformHistory(this.order.refund);
        this.manualRefund = false;

        this.reason = this.reason || "";
    }

    onSave () {
        this.messageService.clear();
        this.error = '';
        this.refundedAmount = this.order.refundable_amount;

        if (!this.validate()) {
            this.messageService.failure(this.error);
            this.messageService.push();
            this.saving = false;
            return Promise.reject({ data: {} });
        }

        let reason = this.reason;
        if (reason === 'Other') {
            reason = this.customReason;
        }

        this.refundedAmount = clone(parseInt(this.refundAmount));

        reason = `Refunded ${this.moneyService.reduce(this.refundAmount, this.order.currency_code)}. ${reason}`;

        return this.refundService.save(this.order, {
            amount: parseInt(this.refundAmount),
            reason: reason,
            manual_refund: this.manualRefund
        });
    }

    onSuccess () {
        this.clearInputs();

        return this.refundService.getHistory(this.order).then(response => {
            this.messageService.success(`Amount refunded successfully.`);
            this.messageService.push();

            this.transformHistory(response);
        });
    }

    onError () {
        return this.refundService.getHistory(this.order).then(response => {
            this.messageService.failure(`Refund was unsuccessful.`);
            this.messageService.push();

            this.transformHistory(response);
        });
    }

    validate () {
        if (this.refundAmount > this.order.refundable_amount) {
            this.error = 'The refund amount must be less than or equal to the remaining Order total.';
            return false;
        }

        if (this.refundAmount < 1) {
            this.error = 'The refund amount must greater than 0.';
            return false;
        }

        if (!this.reason || (this.reason === 'Other' && !this.customReason)) {
            this.error = 'You must specify a reason for this refund.';
            return false;
        }

        return true;
    }

    validateAmount () {
        this.amountError = false;
        if (this.refundAmount > this.order.refundable_amount) {
            this.amountError = true;
        }
    }

    clearReason () {
        this.customReason = '';
    }

    clearInputs () {
        this.order.refundable_amount -= this.refundedAmount;
        this.refundAmount = this.order.refundable_amount;
        this.reason = '';
        this.customReason = '';
    }

    transformHistory (transactions) {
        let paidTransaction = this.order.transaction.find(transaction => {
            return transaction.code === '200';
        });
        if (paidTransaction && paidTransaction.details) {
            paidTransaction.notes = [`Payment taken successfully for ${this.moneyService.reduce(paidTransaction.details.amount, this.order.currency_code)}`];
            transactions.push(paidTransaction);
        }
        this.refundHistory = groupBy(transactions, (transaction) => {
            return transaction.created_at.substring(0, 10);
        });
    }

    showRefunds () {
        return [4, 15, 16, 17, 18, 20, 21, 22, 23].indexOf(this.order.payment_status_id) > -1;
    }

    disableRefundForm () {
        return [20, 22, 23].indexOf(this.order.payment_status_id) > -1;
    }

    disabledReason () {
        switch (this.order.payment_status_id) {
            case 20:
                return `There is an open payment dispute which must be resolved before refunds can be made.`;
            case 22:
                return `A payment dispute was lost and the total value has already been automatically refunded to the customer.`;
            case 23:
                return `A previous refund attempt to this card has failed. The purchaser will need to contact their card issuer but may also contact you.`;
        }
    }

    cannotRefund () {
        return this.order.refundable_amount <= 0 && Object.keys(this.refundHistory).length === 0;
    }

    alreadyRefunded () {
        return this.order.refundable_amount <= 0 && Object.keys(this.refundHistory).length > 0;
    }

    canRefund () {
        return this.order.refundable_amount > 0;
    }
}

OrderRefundController.$inject = ['moneyService', 'refundService', 'messageService'];

export default OrderRefundController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/controllers/order.refund.controller.js